<div *ngIf="vendors?.length > 0" class="comment-widgets">
    <!--Store Names -->
    <div>
        <div class="text-center p-t-10 border-bottom">
            <p class="font-c1 p-b-10"><b>Lugares de canje:</b></p>
        </div>

        <!-- List -->
        <div *ngFor="let sourceItem of source; let i = index">
            <!-- Muestra las 2 primeras tiendas normales o 3, cuando el total de tiendas es 3 -->
            <div *ngIf="(i < 2) || (source?.length == 3)" class="cursor-pointer comment-row">
                <div class="d-flex">
                    <div class="w-100" [ngClass]="{'d-flex align-items-center' : sourceItem.phone.length <= 0}">
                        <div class="font-bold">
                            <i class="mdi mdi-storefront-outline text-dark mr-2" style="font-size: 1.1rem;"></i>
                            <span class="font-c1"><b>{{sourceItem.name}}</b></span>
                        </div>
                        <div *ngIf="sourceItem.phone" class="font-c1">
                            <i class="mdi mdi-phone-outline text-dark mr-1" style="font-size: 1.1rem;"></i>
                            <b>Teléfono: </b> <span>{{sourceItem.phone | mask: '0000-0000'}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- Muestra opacidad en la 3 tienda cuando hay mas de 3 tiendas -->
            <div *ngIf="i == 2 && source?.length > 3 && !showAllStores" class="cursor-pointer comment-row">
                <div class="d-flex" style="position: relative;" (click)="validAllStore()">
                    <div class="w-100 opacity-text">
                        <div class="font-bold">
                            <i class="mdi mdi-storefront-outline text-dark mr-2" style="font-size: 1.1rem;"></i>
                            <span class="font-c1"><b>{{sourceItem.name}}</b></span>
                        </div>
                        <div *ngIf="sourceItem.phone" class="font-c1">
                            <i class="mdi mdi-phone-outline text-dark mr-1" style="font-size: 1.1rem;"></i>
                            <b>Teléfono: </b> <span>{{sourceItem.phone | mask: '0000-0000'}}</span>
                        </div>
                    </div>
                    <div style="position: absolute; padding-top: 15%; padding-left: 28%;"
                        *ngIf="source?.length > 3 && !showAllStores">
                        <button class="btn btn-rounded btn-tag-primary nav-link active white-text"
                            style="background-color: #000 !important;" (click)="validAllStore()">
                            <b>Ver más lugares de canje</b></button>
                    </div>
                </div>
            </div>
            <!-- Se muestran todas las tiendas normales -->
            <div *ngIf="i >= 2 && showAllStores" class="cursor-pointer comment-row">
                <div class="d-flex">
                    <div class="w-100" [ngClass]="{'d-flex align-items-center' : sourceItem.phone.length <= 0}">
                        <div class="font-bold">
                            <i class="mdi mdi-storefront-outline text-dark mr-2" style="font-size: 1.1rem;"></i>
                            <span class="font-c1"><b>{{sourceItem.name}}</b></span>
                        </div>
                        <div *ngIf="sourceItem.phone" class="font-c1">
                            <i class="mdi mdi-phone-outline text-dark mr-1" style="font-size: 1.1rem;"></i>
                            <b>Teléfono: </b> <span>{{sourceItem.phone | mask: '0000-0000'}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="source?.length > 3" class="text-right" (click)="validAllStore()">
            <p *ngIf="showAllStores" class="font-c1 text-dark cursor-pointer  m-t-16">
                <u>Ocultar los lugares de canje</u>
            </p>
        </div>
    </div>
</div>